/* eslint-disable @typescript-eslint/no-shadow */
import { Action } from '@ngrx/store';
import { Options } from '../../models/invoices/segments.options.model';

export enum ActionTypes {
  Change = '[Account Segments] Options change',
  Reset = '[Account Segments] Options reset',
  Apply = '[Account Segments] Options apply'
}

export class Change implements Action {
  readonly type = ActionTypes.Change;
  constructor(public payload: { options: Options; apply: boolean }) {}
}

export class Reset implements Action {
  readonly type = ActionTypes.Reset;
  constructor(public payload?: { options: Options }) {}
}

export class Apply implements Action {
  readonly type = ActionTypes.Apply;
}

export type ActionList = Change | Reset | Apply;
